/**
 * 网络请求
 */
import api from '../../api'

// 根据城市查询门店列表
export const getBoutiqueByCity = params => {
  return api.getBoutiqueByCity(params).then(res => {
    return res.data || []
  })
}

// 获取默认置顶粉丝群列表
export const getDefaultTopLiveFansGroup = channel => {
  return api.getDefaultTopLiveFansGroup(channel).then(res => {
    return res.data || {}
  })
}
